import { Attachments } from "./Claims";

export class CompAttachmentsMdl {
   public ProposalNo: string;
   public frontImage: string;
   public backImage: string;
   public leftImage: string;
   public rightImage: string;
   public chasisImage: string;
   public InsuredIdImage: string;
   public IsthimaraImage: string;
   public CustomIdImage: string;

   public frontImageExists: boolean;
   public backImageExists: boolean;
   public leftImageExists: boolean;
   public rightImageExists: boolean;
   public chasisImageExists: boolean;
   public InsuredIdImageExists: boolean;
   public IsthimaraImageExists: boolean;
}

export class mdlattachments {
   public ProposalNo: string|null;
   public frontImage: string|null;
   public backImage: string|null;
   public leftImage: string|null;
   public rightImage: string|null;
   public chasisImage: string|null;
   public InsuredIdImage: string|null;
   public IsthimaraImage: string|null;
   public CustomIdImage: string|null;


   public frontBase64Image: string|null;
   public backBase64Image: string|null;
   public leftBase64Image: string|null;
   public rightBase64Image: string|null;
   public chasisBase64Image: string|null;
   public InsuredIdBase64Image: string|null;
   public IsthimaraBase64Image: string|null;
   public CustomIdBase64Image: string|null;

   public frontImageExists: boolean;
   public backImageExists: boolean;
   public leftImageExists: boolean;
   public rightImageExists: boolean;
   public chasisImageExists: boolean;
   public InsuredIdImageExists: boolean;
   public IsthimaraImageExists: boolean;
   public CustomIdImageExists: boolean;
}

export class mdlStatus{
   public StatusCode: string = "";
   public StatusDesc: string = "";
   public StatusDescAr: string = "";
}

export class ClaimAttachmentsMdl{
    public TPLClaimImage: string;
    public TrafficPlcImage: string;
    public AccidentClaimImage: string;
    public DriverLicenceImage: string;
    public VehicleLcncImage: string;
    public VehicleApprovedCenterImage: string;
    public DamagedVehicleImage: string; 
    public DamagedVehicleOwnerImage:string;
    public OwnerIBANImage:string;
    public AffectedVhicleLcnImage:string;
    public NajmReportImage:string;
    public RepairShopsImage:string;
    public OtherDocsImage:string;
    public IBANCopyImage:string;
    public AgentsIDImage:string;
    public PwrAttorneyImage:string;
    public InherInventoryImage:string;
    public OfficialJudgementImage:string;

    public ODClaimImage: string;
    public InsuranceCertificateImage :string;
    public DrivingDelegateImage :string;
    public RepairPermissionImage :string;
    public ThirdPartyInsuranceImage :string;
}
export class mdlClaimAttachments{
    public ProductCode: string;
    public ClaimType: string;
    public ClaimTypeCode : number;
    public AttachmentDesc: string;
    public AttachmentShortDesc : string;
    public ImageOrDocument: string;
    public ImageList:Array<Attachments>=new Array<Attachments>();
    public MaxImageListLength:number;
    public Part: number;
    public IsMandatory:boolean;
    public AttachmentDescAr:string;
}



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Models/CompAttachmentsMdl.ts